/* DOSPORDOS 2026: fechas orientativas, hora local de preparación (Europe/Madrid). */
(function () {
  'use strict';

  var ZONE = 'Europe/Madrid';
  var formatMadrid = new Intl.DateTimeFormat('en-GB', {
    timeZone: ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });
  var formatSpanish = new Intl.DateTimeFormat('es-ES', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
  });
  var formatDispatch = new Intl.DateTimeFormat('es-ES', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
  });

  function localParts(now) {
    var data = {};
    formatMadrid.formatToParts(now).forEach(function (part) {
      if (part.type !== 'literal') data[part.type] = Number(part.value);
    });
    return data;
  }

  function isBusinessDay(date) {
    var day = date.getUTCDay();
    return day !== 0 && day !== 6;
  }

  function addBusinessDays(fromDate, amount) {
    var day = new Date(fromDate.getTime());
    var remaining = amount;
    while (remaining > 0) {
      day.setUTCDate(day.getUTCDate() + 1);
      if (isBusinessDay(day)) remaining -= 1;
    }
    return day;
  }

  function datesFor(now) {
    var local = localParts(now);
    var dispatch = new Date(Date.UTC(local.year, local.month - 1, local.day, 12));
    var todayIsBusiness = isBusinessDay(dispatch);
    var beforeCutoff = local.hour < 12;
    if (!todayIsBusiness || !beforeCutoff) {
      dispatch = addBusinessDays(dispatch, 1);
    }
    return {
      dispatch: dispatch,
      first: addBusinessDays(dispatch, 1),
      last: addBusinessDays(dispatch, 2),
      today: todayIsBusiness && beforeCutoff
    };
  }

  function refreshElement(element) {
    if (!element) return;
    var range = element.querySelector('[data-d2d-delivery-range]');
    var dispatchText = element.querySelector('[data-d2d-dispatch]');
    if (!range || !dispatchText) return;
    var dates = datesFor(new Date());
    range.textContent = formatSpanish.format(dates.first) + ' – ' + formatSpanish.format(dates.last);
    dispatchText.textContent = dates.today
      ? 'Si compras antes de las 12:00, tu pedido puede salir hoy.'
      : 'Salida prevista: ' + formatDispatch.format(dates.dispatch) + '.';
  }

  function init() {
    document.querySelectorAll('[data-d2d-delivery]').forEach(refreshElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Dawn vuelve a renderizar datos al cambiar de variante.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      var data = payload && payload.data;
      if (!data || !data.sectionId) return;
      var root = document.getElementById('MainProduct-' + data.sectionId);
      if (!root) return;
      var element = root.querySelector('[data-d2d-delivery]');
      if (!element) return;
      element.hidden = !data.variant || !data.variant.available;
      if (!element.hidden) refreshElement(element);
    });
  }
})();
